<template>

    <div class="qtype-2 dd-m-card dd-m-card--quiz-question" :id="'dd-question-' + item.id">
        <h2 class="dd-m-card--quiz-question__title_custom">
            {{itemIndex}}. {{item.text}}

            <div class="dd-m-alert dd-m-alert--danger" v-if="hasError">
                <p>{{getTranslateString("Answer all questions to complete the quiz")}}</p>
            </div>
        </h2>

        <ul class="dd-m-card--quiz-question__answers dd-m-card--quiz-question__answers--type-2">
            <li class="dd-m-card--quiz-question__item"
                v-for="(answer, index) in item.answers"
                :key="index"
                v-bind:class="{ 'is-selected': selected == answer.id }">
                <input v-model="selected"
                       type="radio"
                       :name="'answer' + item.type + item.position"
                       :value="answer.id"
                       @change="updateAnswer(answer.id)"
                       class="dd-m-card--quiz-question__input"/>

                <label class="dd-m-card--quiz-question__label">
	                <img v-if="answer.image" :src="answer.image ? answer.image.mobile :''"/>
                    <span class="dd-m-card--quiz-question__select">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 496 496" style="enable-background:new 0 0 496 496;" xml:space="preserve" width="55px" height="55px">
                            <path d="M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z      M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z" fill="white"/>
                            <path d="M370.344,158.344L208,320.688l-82.344-82.344c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116     l88,88c3.124,3.123,8.188,3.123,11.312,0l168-168c3.07-3.178,2.982-8.242-0.196-11.312     C378.359,155.35,373.444,155.35,370.344,158.344z" fill="white"/>
                        </svg>
                    </span>
                </label>

                <span class="question_answer">{{answer.text}}</span>
            </li>
        </ul>
    </div>

</template>
<style>
	.dd-m-card--quiz-question__label {
		flex-direction: column;
		justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }
    
    .dd-m-card--quiz-question__label:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        background-image: linear-gradient(to right, #cb7dcb, #ef79a8);
        border-top-left-radius: 125px;
        border-bottom-right-radius: 125px;
        z-index: 2; 
        transition: all 0.3s ease;
    }
    .dd-m-card--quiz-question__label:after {
        content: '';
        display: block;
        position: absolute;
        top: 9px;
        left: 9px;
        bottom: 9px;
        right: 9px;
        border: 2px solid #fff;
        opacity: 0;
        z-index: 3;
        border-top-left-radius: 125px;
        border-bottom-right-radius: 125px;
        transition: all 0.3s ease;
    }

	.dd-m-card--quiz-question__label img {
        display: block;
        max-width: 100%;
        border-top-left-radius: 125px;
        border-bottom-right-radius: 125px;
        position: relative;
        z-index: 1;
    }
    .dd-m-card--quiz-question__select {
        z-index: 3;
        width: 55px;
        height: 55px;
        position: absolute;
        bottom: 32px;
        left: 32px;
        opacity: 0;
        transition: all 0.3s ease;
    }
    .dd-m-card--quiz-question__item.is-selected .dd-m-card--quiz-question__label:before {
        opacity: 0.6;
    }
    .dd-m-card--quiz-question__item.is-selected .dd-m-card--quiz-question__label:after,
    .dd-m-card--quiz-question__item.is-selected  .dd-m-card--quiz-question__select{
        opacity: 1;
    }
</style>
<script>
    import ScrollService from "../../providers/scroll";

    const scrollService = new ScrollService();

    export default {
        name: 'card-question-type-2',
        props: ['item', 'offline', 'itemIndex', 'stepAnswered'],
        data: () => {
            return {
                selected: '',
                results: [],
                oldValue: null,
                hasError: false,
                _stepAnswered: this.stepAnswered
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('showError', (msg, param) => {
                    if (this.item.id === param) {
                        this.hasError = true;

                        if (this.offline) {
                            scrollService.doSmoothScrollToFromModal(this.item.offset, 20);
                        } else {
                            scrollService.doSmoothScrollTo(`#dd-question-${this.item.id}`, 138);
                        }
                    }
                });
            },
            updateValue(value) {
            	this._stepAnswered = true;

                PubSub.publish('updateAnswers', value);
                PubSub.publish('updateQuestionsAnswered', {value: this.item.id, remove: false});
                PubSub.publish('selectAnswer', this.item.id);
                this.oldValue = value;
            },
            updateAnswer(value) {
                this.hasError = false;
                if (this.oldValue) {
                    PubSub.publish('updateAnswers', this.oldValue);

                    setTimeout(() => this.updateValue(value), 100);
                } else {
                    this.updateValue(value);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/card-question-type-2.vue